function resolveNextRegion(prevRegion, nextRegions) {
    if (!prevRegion)
        return undefined;
    const exact = nextRegions.find(region => region.name === prevRegion.name && region.pieceName === prevRegion.pieceName);
    if (exact)
        return exact.id;
    const sameName = nextRegions.find(region => region.name === prevRegion.name);
    return sameName === null || sameName === void 0 ? void 0 : sameName.id;
}
function resolveNextPointOfMeasureId(currentPomId, prevPoms, nextPoms) {
    var _a;
    if (!(currentPomId === null || currentPomId === void 0 ? void 0 : currentPomId.trim()))
        return undefined;
    if (nextPoms.some(pom => pom.id === currentPomId))
        return currentPomId;
    if (!nextPoms.length || !prevPoms.length)
        return currentPomId;
    const prevPom = prevPoms.find(pom => pom.id === currentPomId);
    if (!prevPom)
        return undefined;
    return (_a = nextPoms.find(pom => pom.name === prevPom.name && pom.pieceName === prevPom.pieceName)) === null || _a === void 0 ? void 0 : _a.id;
}
/**
 * Point logos at the equivalent region and point of measure on another colorway.
 * Region match is name plus piece, then name. An unmatched region id is left as-is.
 */
export function reconcileLogosForNextColorway(logos, prevRegions, nextRegions, prevPoms, nextPoms) {
    return logos.map(logo => {
        var _a, _b;
        const prevRegion = prevRegions.find(region => region.id === logo.region);
        const nextRegionId = resolveNextRegion(prevRegion, nextRegions);
        const nextPointOfMeasure = ((_a = logo.pointOfMeasure) === null || _a === void 0 ? void 0 : _a.trim())
            ? resolveNextPointOfMeasureId(logo.pointOfMeasure, prevPoms, nextPoms)
            : logo.pointOfMeasure;
        return Object.assign(Object.assign(Object.assign({}, logo), (nextRegionId ? { region: nextRegionId } : {})), (((_b = logo.pointOfMeasure) === null || _b === void 0 ? void 0 : _b.trim()) ? { pointOfMeasure: nextPointOfMeasure } : {}));
    });
}
